import React, { useState } from 'react'
import { DialogContent, DialogHeader, DialogTitle } from '@/Components/ui/dialog'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { Form, FormControl, FormField, FormItem, FormLabel } from '@/Components/ui/form'
import { Input } from '@/Components/ui/input'
import { Button } from '@/Components/ui/button'
import { toast } from 'react-toastify'
import Loader from '@/Components/Common/Loader'
import PayorTypeService from '@/Service/PayorTypeService'
import { useNavigate } from 'react-router-dom'
import WorkflowStateService from '@/Service/WorkflowStateService'

const CreateworkflowState = ({ getWorkflowState, setIsOpen }) => {
    const navigate = useNavigate()
    const formSchema = z.object({
        state: z
            .string({
                message: 'Workflow State is required.',
            })
            .min(1, {
                message: 'Workflow State is required.',
            }),
    })
    const [isSaving, setIsSaving] = useState(false)

    const form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            state: '',
        },
    })

    async function onSubmit(values) {
        try {
            setIsSaving(true)
            const resp = await WorkflowStateService.addWorkflowState(values)
            if (resp.data.success) {
                setIsSaving(false)
                const searchParams = new URLSearchParams(location.search)
                const page = searchParams.get('page')
                if (page) {
                    navigate('/workflow/state')
                } else {
                    getWorkflowState()
                }
                form.reset({ state: '' })
                setIsOpen(false)
            }
        } catch (err) {
            setIsSaving(false)
        }
    }

    function onError(errors, e) {
        const errorKeys = Object.keys(errors)
        if (errorKeys.length > 0 && errors[errorKeys[0]]?.message) {
            toast.error(errors[errorKeys[0]].message)
        }
        console.log(errors, e)
    }

    return (
        <DialogContent>
            <DialogHeader>
                <DialogTitle>Add State</DialogTitle>
            </DialogHeader>
            <div>
                <Form {...form}>
                    <form onSubmit={form.handleSubmit(onSubmit, onError)} className="space-y-4">
                        <FormField
                            control={form.control}
                            name="state"
                            render={({ field }) => (
                                <FormItem className="space-y-1">
                                    <FormLabel required={true}>State</FormLabel>
                                    <FormControl>
                                        <Input
                                            {...field}
                                            className="shadow-none focus-visible:ring-transparent space-0 mt-0"
                                            placeholder="State"
                                        />
                                    </FormControl>
                                </FormItem>
                            )}
                        />
                        <div className="flex justify-end">
                            <Button type="submit" className="bg-primary-purpal hover:bg-primary-purpal " disabled={isSaving}>
                                Save {isSaving && <Loader fullScreen={false} />}
                            </Button>
                        </div>
                    </form>
                </Form>
            </div>
        </DialogContent>
    )
}

export default CreateworkflowState
